import { createClient } from '@supabase/supabase-js';

// Environment variables would be better, but using constants for now
const SUPABASE_URL = 'https://byifwvpmiubelhtdvnag.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5aWZ3dnBtaXViZWxodGR2bmFnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEwMTI2MDksImV4cCI6MjA1NjU4ODYwOX0.eh52HoAPmQ9xhEMSBOiGsL9_28YgyRT87wkKkWCcZtQ';

// Create a single supabase client for interacting with your database
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// Helper function to get the current session
export const getCurrentSession = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data.session;
  } catch (error) {
    console.error('Error getting session:', error.message);
    return null;
  }
};

// Helper function to get the current user
export const getCurrentUser = async () => {
  try {
    const session = await getCurrentSession();
    return session?.user || null;
  } catch (error) {
    console.error('Error getting user:', error.message);
    return null;
  }
};

// Helper function to get the JWT token for API requests
export const getAuthToken = async () => {
  try {
    const session = await getCurrentSession();
    return session?.access_token || null;
  } catch (error) {
    console.error('Error getting token:', error.message);
    return null;
  }
};

// Helper function for API calls to Supabase Edge Functions
export const callEdgeFunction = async (functionName, params = {}) => {
  try {
    const token = await getAuthToken();
    if (!token) throw new Error('No authentication token available');

    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    const url = `${SUPABASE_URL}/functions/v1/${functionName}${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error calling ${functionName}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error in edge function ${functionName}:`, error.message);
    throw error;
  }
};

export default supabase;